import React, { useState } from 'react';

// STYLES
import { Box, Chip, IconButton, InputBase } from '@mui/material';

// ASSETS
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';

export default function ChipArrayContains({
  setGroups,
  values = [],
  groupId,
  itemIndex,
  setInvalidFields,
  error,
}) {
  const [inputValue, setInputValue] = useState('');

  const handleAddChip = (newValue) => {
    setGroups((prevGroups) => {
      // Cria uma cópia do objeto prevGroups
      const updatedGroups = { ...prevGroups };

      // Acessa o grupo específico
      const currentGroup = updatedGroups[groupId];

      // Garante que temos um item no índice especificado
      if (!currentGroup || !currentGroup[itemIndex]) return prevGroups;

      // Garante que value é um array
      const currentItem = { ...currentGroup[itemIndex] };
      const currentValue = Array.isArray(currentItem.value) ? [...currentItem.value] : [];

      // Adiciona se não existir
      if (newValue.trim() && !currentValue.includes(newValue)) {
        currentItem.value = [...currentValue, newValue];

        // Atualiza o grupo com o novo item
        updatedGroups[groupId] = [
          ...currentGroup.slice(0, itemIndex),
          currentItem,
          ...currentGroup.slice(itemIndex + 1),
        ];
      }

      return updatedGroups;
    });

    // Limpa o erro para este campo
    setInvalidFields((prev) => {
      const newErrors = { ...prev };
      if (newErrors[groupId]?.[itemIndex] !== undefined) {
        delete newErrors[groupId][itemIndex];
        if (Object.keys(newErrors[groupId]).length === 0) {
          delete newErrors[groupId];
        }
      }
      return newErrors;
    });
  };

  const handleDeleteChip = (chipIndex) => {
    setGroups((prevGroups) => {
      // Cria uma cópia do objeto prevGroups
      const updatedGroups = { ...prevGroups };

      // Acessa o grupo específico
      const currentGroup = updatedGroups[groupId];

      // Garante que temos um item no índice especificado
      if (!currentGroup || !currentGroup[itemIndex]) return prevGroups;

      // Garante que value é um array
      const currentItem = { ...currentGroup[itemIndex] };
      const currentValue = Array.isArray(currentItem.value) ? [...currentItem.value] : [];

      // Remove o item
      currentValue.splice(chipIndex, 1);
      currentItem.value = currentValue;

      // Atualiza o grupo com o novo item
      updatedGroups[groupId] = [
        ...currentGroup.slice(0, itemIndex),
        currentItem,
        ...currentGroup.slice(itemIndex + 1),
      ];

      return updatedGroups;
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && inputValue.trim()) {
      e.preventDefault();
      e.stopPropagation();
      handleAddChip(inputValue.trim());
      setInputValue('');
    }
  };

  const handleAdd = (e) => {
    e.stopPropagation();
    if (inputValue.trim()) {
      handleAddChip(inputValue.trim());
      setInputValue('');
    }
  };

  const handleBlur = () => {
    if (inputValue.trim()) {
      handleAddChip(inputValue.trim());
      setInputValue('');
    }
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 1,
          p: 1,
          border: error ? '1px solid red' : '1px solid #ccc',
          borderRadius: 1,
          minHeight: '56px',
          '&:focus-within': {
            borderColor: error ? 'red' : 'primary.main',
          },
        }}
      >
        {values.map((value, index) => (
          <Chip
            key={index}
            label={value}
            onDelete={() => handleDeleteChip(index)}
            deleteIcon={<CloseIcon />}
            size="small"
          />
        ))}

        <Box sx={{ flexGrow: 1, minWidth: '120px' }}>
          <InputBase
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
            onBlur={handleBlur}
            fullWidth
            sx={{ px: 1 }}
            placeholder="Adicionar valor"
          />
        </Box>

        <IconButton onClick={handleAdd} size="small">
          <AddIcon />
        </IconButton>
      </Box>
    </Box>
  );
}
